import { Stack } from '@mantine/core';
import { Divider } from '../../../../../ui-library/divider/divider';
import { SideSectionInfo } from './side-section-info';
import { SideSectionTargets } from './side-section-targets';

export const SideSectionDetails = () => {
  return (
    <Stack>
      <SideSectionInfo />
      <Divider />
      <SideSectionTargets />
    </Stack>
  );
};
